import React from 'react';
import { Pagination } from 'react-bootstrap';

const Paginator = ({ currentPage, totalPages, onPageChange }) => {
  const handleClick = (page) => {
      onPageChange(page);
  };
  const getPageNumbers = () => {
    const maxVisiblePages = 5;
    let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };
  return (
    <Pagination className="justify-content-center">
        <Pagination.Prev
            onClick={() => handleClick(currentPage - 1)}
            disabled={currentPage === 1}
        />

    {currentPage > 3 && totalPages > 5 && (
      <Pagination.Item onClick={() => handleClick(1)}>1</Pagination.Item>
    )}

    {currentPage > 4 && <Pagination.Ellipsis disabled />}

    {getPageNumbers().map((page) => (
      <Pagination.Item
        key={page}
        active={page === currentPage}
        onClick={() => handleClick(page)}
      >
        {page}
      </Pagination.Item>
    ))}

    {currentPage < totalPages - 3 && <Pagination.Ellipsis disabled />}

    {currentPage < totalPages - 2 && totalPages > 5 && (
      <Pagination.Item onClick={() => handleClick(totalPages)}>
        {totalPages}
      </Pagination.Item>
    )}

        <Pagination.Next
            onClick={() => handleClick(currentPage + 1)}
            disabled={currentPage === totalPages}
        />
    </Pagination>
  );
};

export default Paginator;